
import React from 'react';
import { Button } from "@/components/ui/button";
import { MessageSquare, Calendar } from "lucide-react";
import { useClientNotifications } from '@/hooks/useClientNotifications';

interface ClientMessagingProps {
  clientId: string;
  phone: string;
  lastVisit?: Date | null;
}

export function ClientMessaging({ clientId, phone, lastVisit }: ClientMessagingProps) {
  const { sendRebookingReminder, sendAppointmentReminder, isSending } = useClientNotifications();

  if (!phone) {
    return (
      <div className="text-sm text-muted-foreground">
        No phone number available for messaging
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium">Client Communication</h4>
      <div className="flex flex-wrap gap-2">
        {lastVisit && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => sendRebookingReminder(clientId, phone, lastVisit)}
            disabled={isSending}
          >
            <MessageSquare className="h-4 w-4 mr-2" />
            Send Rebooking Reminder
          </Button>
        )}
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            // For testing, we'll send a reminder for an appointment tomorrow
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            sendAppointmentReminder(clientId, phone, tomorrow, "John D.");
          }}
          disabled={isSending}
        >
          <Calendar className="h-4 w-4 mr-2" />
          Send Test Reminder
        </Button>
      </div>
    </div>
  );
}
